import { Badge } from 'slab'
import {
  useGetEmployersAcaReportingFilingEligibility,
  useGetEmployersAcaReportingNeedsAleConfirmation,
  useGetEmployersAcaReportingStatus
} from 'utils/web_api'

interface ACAReportingBadgeProps {
  planYear: number
}

export default function ACAReportingBadge ({ planYear }: ACAReportingBadgeProps) {
  const { data: filingData, isLoading: filingLoading } = useGetEmployersAcaReportingFilingEligibility(
    { plan_year: planYear },
    {
      query: {
        retry: false
      }
    }
  )

  const { data: statusData, isLoading: statusLoading } = useGetEmployersAcaReportingStatus(
    { plan_year: planYear },
    {
      query: {
        retry: false,
        enabled: filingData?.aca_filing_enabled === true
      }
    }
  )

  const { data: aleData, isLoading: aleLoading } = useGetEmployersAcaReportingNeedsAleConfirmation(
    { plan_year: planYear },
    {
      query: {
        retry: false,
        enabled: !filingLoading
      }
    }
  )

  if (filingLoading || statusLoading || aleLoading) {
    return null
  }

  const badgeStatus = computeBadgeStatus(filingData, statusData, aleData)

  if (!badgeStatus) {
    return null
  }

  return (
    <span className='ml-2'>
      {badgeStatus === 'needs_action' && (
        <Badge type='caution' bordered>Complete by Feb 1</Badge>
      )}
      {badgeStatus === 'filing_pending' && (
        <Badge type='info' bordered>Filing pending</Badge>
      )}
      {badgeStatus === 'opted_out' && (
        <Badge type='neutral' bordered>Opted out</Badge>
      )}
      {badgeStatus === 'expired' && (
        <Badge type='neutral' bordered>Expired</Badge>
      )}
    </span>
  )
}

function computeBadgeStatus (
  filingData: { aca_filing_enabled?: boolean } | undefined,
  statusData: { status?: string } | undefined,
  aleData: { needs_confirmation?: boolean; ale_status?: boolean } | undefined
): 'needs_action' | 'filing_pending' | 'opted_out' | 'expired' | null {
  if (!filingData) return null

  if (filingData.aca_filing_enabled) {
    if (!statusData) {
      return 'needs_action'
    }

    switch (statusData.status) {
      case 'opted_in':
        return 'filing_pending'
      case 'opted_out':
        return 'opted_out'
      case 'expired':
        return 'expired'
      default:
        return null
    }
  } else {
    return aleData?.needs_confirmation ? 'needs_action' : null
  }
}
